import { render, staticRenderFns } from "./RentACarInformation.vue?vue&type=template&id=228a99c4&scoped=true"
import script from "./RentACarInformation.vue?vue&type=script&lang=js"
export * from "./RentACarInformation.vue?vue&type=script&lang=js"
import style0 from "./RentACarInformation.vue?vue&type=style&index=0&id=228a99c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a99c4",
  null
  
)

export default component.exports